export function isNotNumber(val){
  return (
    val === 'auto' ||
    val === '-webkit-fill-available'
  )
}
